import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    toolbarTitle: "",
    toolIds: [] as string[],
    dataHost: process.env.VUE_APP_DATA_HTTP
  },
  mutations: {
    setToolbarTitle(state, title: string) {
      state.toolbarTitle = title;
    },
    setToolIds(state, ids: string[]) {
      state.toolIds = ids;
    }
  },
  actions: {}
});
